module.exports = __webpack_public_path__ + "static/media/unlock-1.1s-100px.0449967a.svg";